exports.StringToDateTimeTransformer = () => {
  return {
    convertToVersionOne: (zonedDateTime) => zonedDateTime.toISOString(),
    convertToVersionTwo: (string) => {
      const date = new Date(string)
      return date.toString() !== "Invalid Date" ? date.toISOString() : ''
    }
  }
}


// WEBPACK FOOTER //
// ./node_modules/@abc/transformers/src/transformers/lineItem/dateTime/index.js